import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Eyebrow from "@/components/common/Eyebrow";
import HeroSearchBar from "./HeroSearchBar";
import { HERO_IMAGE } from "@/constants/homeContent";

export default function Hero() {
  return (
    <Box sx={{ position: "relative", minHeight: { xs: 520, md: 560 }, display: "flex", flexDirection: "column", justifyContent: "center", overflow: "hidden" }} data-testid="hero-section">
      <Box sx={{ position: "absolute", inset: 0 }}>
        <Box component="img" src={HERO_IMAGE} alt="" sx={{ width: "100%", height: "100%", objectFit: "cover" }} />
        <Box
          sx={{
            position: "absolute", inset: 0,
            background: (t) => t.palette.mode === "dark"
              ? "linear-gradient(180deg, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0.55) 55%, rgba(0,0,0,0.85) 100%)"
              : "linear-gradient(180deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.3) 55%, rgba(0,0,0,0.6) 100%)",
          }}
        />
      </Box>

      <Box sx={{ position: "relative", zIndex: 1, maxWidth: 1400, width: "100%", mx: "auto", px: { xs: 3, lg: 6 }, pb: { xs: 4, md: 5 }, pt: { xs: 10, md: 11 } }}>
        <Eyebrow sx={{ color: "rgba(255,255,255,0.85)", mb: 2 }}>Private villas. Extraordinary stays.</Eyebrow>
        <Typography component="h1" className="font-serif-display" sx={{ color: "#fff", fontSize: { xs: 40, sm: 52, md: 64 }, lineHeight: 1.05, letterSpacing: "-0.01em", maxWidth: 640, mb: 2.5 }} data-testid="hero-headline">
          Stay somewhere extraordinary.
        </Typography>
        <Typography sx={{ color: "rgba(255,255,255,0.85)", fontSize: { xs: 15, md: 17 }, mb: 4, maxWidth: 480 }}>
          Handpicked private villas for unforgettable getaways.
        </Typography>

        <HeroSearchBar />
      </Box>

      <Typography
        className="font-serif-display"
        sx={{
          position: "absolute", zIndex: 1, right: { xs: 20, md: 56 }, bottom: { xs: 20, md: 28 },
          color: "rgba(255,255,255,0.85)", fontStyle: "italic", fontSize: { xs: 13, md: 17 },
          transform: "rotate(-4deg)", display: { xs: "none", sm: "block" },
        }}
      >
        Good Stays, Better Stories
      </Typography>
    </Box>
  );
}
